import { render, staticRenderFns } from "./step-contacts-location-country.vue?vue&type=template&id=0882dc99"
import script from "./step-contacts-location-country.vue?vue&type=script&lang=ts"
export * from "./step-contacts-location-country.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports